<script setup lang="ts">
interface Props {
  heading: string
  text?: string
  buttonText?: string
  fluidButton?: boolean
  asDialog?: boolean
}

defineProps<Props>()
const { hide, show, visible } = useVisible()
</script>
<template>
  <template v-if="asDialog">
    <PvButton
      size="small"
      class="px-2 py-1 gap-1"
      :fluid="fluidButton"
      severity="warn"
      @click="show"
    >
      <span class="icon-[ph--info-bold]" />
      {{ buttonText ?? heading }}
    </PvButton>
    <PvDialog
      :header="heading"
      :show-header="false"
      class="max-w-[90%] md:w-[75rem]"
      :visible
    >
      <PvButton
        class="absolute aspect-square right-2 top-2 p-0"
        rounded
        @click="hide"
      >
        <span class="icon-[ph--x-circle-bold] text-current text-2xl" />
      </PvButton>
      <FormsGlobalAssistanceBody
        :heading
        :text
      />
    </PvDialog>
  </template>
  <template v-else>
    <CardComponent bg="light">
      <FormsGlobalAssistanceBody
        :heading
        :text
      />
    </CardComponent>
  </template>
</template>
